export default __webpack_public_path__ + "static/article-latitude-credit-card-insurance-benefits-9bca8d08f00a94543d6f9f65a2272b1c.jpg";